import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper';
import EfImg from '@elem/ui/ef-img';
import { Img_List } from '../common';
import styles from './index.module.scss';
import useSwiperAnimate from './useSwiperAnimate';

const Arrow = ({ style }: any) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={style} xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4957_3263)">
            <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_4957_3263">
                <rect width="24" height="24" fill="white" transform="translate(24) rotate(90)" />
            </clipPath>
        </defs>
    </svg>
);

function DeviceSwiper() {
    const { slideChangeHandle, hanldleMouseEnter, hanldleMouseLeave, changeSwiper } = useSwiperAnimate({
        swiperClassName: 'device-swiper',
        list: Img_List,
    });

    return (
        <div className={styles.TheComp}>
            <Swiper
                // className={`swiper-box ${swiperArr?.length > 1 ? '' : 'single'}`}
                className="device-swiper"
                modules={[Pagination, Navigation]}
                spaceBetween={0}
                loop
                autoplay
                initialSlide={0}
                navigation={{
                    prevEl: '.device-swiper-navigation-left',
                    nextEl: '.device-swiper-navigation-right',
                }}
                slidesPerView={'auto'}
                pagination={Img_List?.length > 1 ? { clickable: true } : false}
                onSlideChange={slideChangeHandle}
                onSwiper={changeSwiper}
            >
                {Img_List.map((item, idx) => (
                    <SwiperSlide className="swiper-item" key={idx} onMouseEnter={hanldleMouseEnter} onMouseLeave={hanldleMouseLeave}>
                        <EfImg pc={item} />
                    </SwiperSlide>
                ))}
            </Swiper>
            {Img_List?.length > 1 && (
                <>
                    <button className="device-swiper-navigation device-swiper-navigation-left">
                        <Arrow />
                    </button>
                    <button className="device-swiper-navigation device-swiper-navigation-right">
                        <Arrow />
                    </button>
                </>
            )}
        </div>
    );
}

export default DeviceSwiper;
